/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { RESIGNATION_TYPE, UPDATE_NEED_CHANGE_EMAIL_STATUS } from '../../core/configs/constants';
import { useState, useEffect } from 'react'; 

import { useStore } from '../../core/utils/hook';
import classNames from 'classnames';
import { flowResult } from 'mobx';

const ResignedConfirmModal = observer(({ isPopup = false, userInfo, hide, setStep, originalData }) => {
    const [resignationType, setResignationType] = useState(RESIGNATION_TYPE.CONTINUE);
    
   
    const [countdown, setCountdown] = useState(5);
    const [isDisabled, setIsDisabled] = useState(true);

    const {
        authStore: {
            updateNeedChangeEmail, saveUserInfo
        }
    } = useStore();

   
    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } else {
            setIsDisabled(false); // Enable the button when countdown reaches 0
        }

        return () => clearInterval(timer); // Cleanup on unmount
    }, [countdown]);

    const handleSubmit = async () => {
        try {
            const res = await flowResult(updateNeedChangeEmail({
                status: UPDATE_NEED_CHANGE_EMAIL_STATUS.APPROVED
            }));
            if (res?.ok) {
                setStep(3);
                hide();
            }
        } catch (error) {
            console.log(error);
        } 
    }

    const onClose = async () => {
        try {
            const res = await flowResult(updateNeedChangeEmail({
                status: UPDATE_NEED_CHANGE_EMAIL_STATUS.REJECTED
            }));
            if (res?.ok) {
                if (!userInfo?.is2FA) {
                    setStep(2);
                } else {
                    saveUserInfo(originalData, true)
                    localStorage.setItem('token', originalData?.token || originalData?.tempToken );
                    localStorage.removeItem('tempToken');
                    window.location.reload();
                }

                hide();
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className={classNames(isPopup ? '' : 'col-md-10 col-lg-10 col-12 container-tool-certificate')}>
            <div className='row'>
                <div className='col-12 tool-certificate-input-type d-flex flex-gap-20 mb-3'>
                    <div style={{ minWidth: '178px', display: 'flex', flexDirection: 'column', gap: '0px' }}>
                        <span>以前所属していた法人管理者により退職者に変更されました。</span>
                        <span>
                           会社付与のメールアドレスをご利用の場合は、新しいメールアドレスへ変更してください。
                        </span>
                        <div style={{ color: 'red', marginTop: '15px' }}>
                            ※現在、「所属会社名」は空欄となっておりますので、所属先が決まり次第、アカウント画面にてご登録をお願いいたします。
                        </div>
                    </div>

                </div>
                <div style={{ 
                    marginTop: '10px',
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '50px',
                    borderTop: '1px solid #d3d3d3',
                    padding: '20px' 
                }}>
                    <button 
                        className='btn-cancel-2'
                        type='button' 
                        style={{ 
                            width: '180px', 
                            height: '45px',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            opacity: isDisabled ? 0.6 : 1
                        }}
                        onClick={onClose}
                        disabled={isDisabled} 
                    >
                        キャンセル {isDisabled && `(${countdown})`}
                    </button>
                    <button 
                        className='btn-default-5'
                        type='submit'
                        style={{ 
                            width: '230px', 
                            height: '45px',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            opacity: isDisabled ? 0.6 : 1
                        }}
                        onClick={() => handleSubmit(userInfo.id)}
                        disabled={isDisabled} 
                    >
                        メールアドレスを更新する
                    </button> 
                </div>
            </div>
        </div>
    )
})

export default ResignedConfirmModal;